module.exports = __webpack_public_path__ + "build/assets/STIXTwoText-Bold-235c30dc3a5c8ef3f517d79bc31e07a1.woff2";